import store from '@/store'

const ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN'
const ROLE_SYSTEM_ADMIN = 'ROLE_SYSTEM_ADMIN'
const USER_TYPE_NORMAL = 0
const USER_TYPE_ADMIN = 1

const hasRole = (roles) => {
  const user = store.state.app.userInfo
  if (user && user.authorities) {
    for (const role of roles) {
      if (user.authorities.includes(role)) {
        return true
      }
    }
  }
  return false
}

const isNormalUser = () => {
  const user = store.state.app.userInfo
  return user.type === USER_TYPE_NORMAL
}

export const isPartner = () => {
  const user = store.state.app.userInfo
  return user && user.partnerType > 0
}

export const hasAuthority = (authorities) => {
  const user = store.state.app.userInfo
  if (user && !isNormalUser() && user.authorizedModules) {
    const authoritiesList = authorities instanceof Array ? authorities : [authorities]
    for (const authority of authoritiesList) {
      if (user.authorizedModules.includes(authority)) {
        return true
      }
    }
  }
  return false
}

export const hasPermission = (permissions) => {
  const user = store.state.app.userInfo
  if (user && !isNormalUser() && user.authorities) {
    const permissionsList = permissions instanceof Array ? permissions : [permissions]
    for (const permission of permissionsList) {
      if (user.authorities.includes(permission)) {
        return true
      }
    }
  }
  return false
}

export const isAdmin = () => {
  return hasRole([ROLE_SUPER_ADMIN, ROLE_SYSTEM_ADMIN])
}

